export default __webpack_public_path__ + "static/media/NextArrowHover.b32e1d95.svg";